import { DialogActions } from "@material-ui/core";

function MaterialDialogActions ( props ) {

    return <DialogActions {...props} />

}

export default MaterialDialogActions;
